/* ============================================================
   Netflix-poster.js  —  Spark Store Custom Netflix Poster
   ============================================================ */
(function () {
  'use strict';

  /* ── CONFIG ───────────────────────────────────────────── */
  var SIZE_CONFIG = {
    '20*30': { ratio:'ratio-2-3', solidPx:160, fadePx:120, wCm:20, hCm:30 },
    '30*40': { ratio:'ratio-3-4', solidPx:140, fadePx:110, wCm:30, hCm:40 },
    '40*50': { ratio:'ratio-4-5', solidPx:130, fadePx:100, wCm:40, hCm:50 },
    '50*70': { ratio:'ratio-5-7', solidPx:155, fadePx:115, wCm:50, hCm:70 },
  };
  var DEFAULT_SIZE = '20*30';
  var SAFE_CM      = 1.25;
  var TOP_GRAD_H   = 100;
  var MIN_DPI      = 150;
  var NETFLIX_LOGO = 'https://cdn.shopify.com/s/files/1/0593/4894/2931/files/500px-Netflix_2016_N_logo_svg.png?v=1778314380';
  var TOTAL_STEPS  = 5;

  /* ── STATE ────────────────────────────────────────────── */
  var state = {
    step: 1,
    rating: 'PG-13', photoFile: null, photoURL: null,
    selectedOptions: {}, currentSize: DEFAULT_SIZE, panX: 0, panY: 0,
  };
  var drag  = { active:false, startX:0, startY:0, startPanX:0, startPanY:0 };
  var els   = {};
  var logoImg = null;
  var adjustCanvas = null, adjustCtx = null, adjustImg = null;
  var gradRaf = null;

  function safePx(px, cm) { return (SAFE_CM / cm) * px; }
  function g(id) { return document.getElementById(id); }

  /* ── SPINNER ──────────────────────────────────────────── */
  function showSpinner(btn) {
    var orig = btn.innerHTML;
    btn.innerHTML =
      '<span style="display:inline-flex;align-items:center;gap:8px;">' +
      '<svg width="16" height="16" viewBox="0 0 16 16" style="animation:np-spin 0.7s linear infinite;flex-shrink:0;">' +
      '<circle cx="8" cy="8" r="6" fill="none" stroke="rgba(255,255,255,0.3)" stroke-width="2"/>' +
      '<path d="M8 2 A6 6 0 0 1 14 8" fill="none" stroke="#fff" stroke-width="2" stroke-linecap="round"/></svg>' +
      '<span id="np-spin-label">Working…</span></span>';
    btn.disabled = true; btn.dataset.sparkBusy = '1';
    return {
      label: function(t) { var l = g('np-spin-label'); if (l) l.textContent = t; },
      restore: function() { btn.innerHTML = orig; btn.disabled = false; delete btn.dataset.sparkBusy; }
    };
  }

  /* ── INIT ─────────────────────────────────────────────── */
  function init() {
    els = {
      titleInput:        g('np-title'),
      descInput:         g('np-desc'),
      castInput:         g('np-cast'),
      yearInput:         g('np-year'),
      genreInput:        g('np-genre'),
      matchSlider:       g('np-match-slider'),
      matchDisplay:      g('np-match-display'),
      photoInput:        g('np-photo-input'),
      uploadZone:        g('np-upload-zone'),
      thumbPreview:      g('np-thumb'),
      posterImg:         g('np-poster-img'),
      photoPlaceholder:  g('np-photo-placeholder'),
      poster:            g('np-poster'),
      gradCanvas:        g('np-grad-canvas'),
      pTitle:            g('np-p-title'),
      pDesc:             g('np-p-desc'),
      pCast:             g('np-p-cast'),
      pYear:             g('np-p-year'),
      pMatch:            g('np-p-match'),
      pRating:           g('np-p-rating'),
      shopifyForm:       g('np-product-form'),
      variantInput:      g('np-variant-id'),
      errorBox:          g('np-error'),
      atcBtn:            g('np-atc-btn'),
      priceDisplay:      g('np-price-display'),
      priceCompare:      g('np-price-compare'),
      hiddenPhotoInput:  g('np-hidden-photo'),
      previewPhotoInput: g('np-preview-photo'),
      btnPrev:           g('np-btn-prev'),
      btnNext:           g('np-btn-next'),
    };
    if (!els.shopifyForm) return;

    if (!g('np-spin-style')) {
      var st = document.createElement('style');
      st.id = 'np-spin-style';
      st.textContent = '@keyframes np-spin{to{transform:rotate(360deg)}}';
      document.head.appendChild(st);
    }

    document.querySelectorAll('.np-pill.active[data-option]').forEach(function (p) {
      state.selectedOptions[p.dataset.option] = p.dataset.value;
      if (p.dataset.value in SIZE_CONFIG) state.currentSize = p.dataset.value;
    });

    logoImg = new Image();
    logoImg.crossOrigin = 'anonymous';
    logoImg.src = NETFLIX_LOGO;

    // Mark mandatory fields with a star
    ['titleInput','descInput','castInput','yearInput','genreInput'].forEach(function(k) {
      var el = els[k]; if (!el) return;
      var label = el.closest('.np-field') && el.closest('.np-field').querySelector('label');
      if (label && !label.querySelector('.np-required')) {
        var star = document.createElement('span');
        star.className = 'np-required'; star.textContent = '*';
        label.appendChild(star);
      }
    });

    bindEvents();
    updatePreview();
    resolveVariant();
    goToStep(1);
    scheduleGradient();
    initPhrasePresets();
    offerDraft();
  }

  /* ── STEPPER ──────────────────────────────────────────── */
  function goToStep(n) {
    state.step = n;
    for (var i = 1; i <= TOTAL_STEPS; i++) {
      var el = g('np-step-' + i);
      if (el) el.style.display = (i === n) ? '' : 'none';
    }
    var fill = g('np-progress-fill');
    if (fill) fill.style.width = ((n / TOTAL_STEPS) * 100) + '%';
    document.querySelectorAll('.np-step-labels span').forEach(function (s) {
      s.classList.toggle('active', parseInt(s.dataset.step) === n);
    });
    if (els.btnPrev) els.btnPrev.style.visibility = (n === 1) ? 'hidden' : 'visible';
    if (els.btnNext) {
      if (n === TOTAL_STEPS) { els.btnNext.style.display = 'none'; }
      else { els.btnNext.style.display = ''; els.btnNext.textContent = (n === TOTAL_STEPS - 1) ? 'Review →' : 'Next →'; }
    }
    if (n === TOTAL_STEPS) buildReview();
    /* Step 4 is "Frame & Size" — the frame snaps in on arrival and stays for
       Review so the customer sees the finished piece, not a bare poster. */
    applyFrame(n >= 4, false);
    hideError();
  }

  function buildReview() {
    var v = getValues();
    var summary = g('np-review-summary'); if (!summary) return;
    var lines = [
      ['Title',  v.title],
      ['Names',  v.cast],
      ['Year',   v.year],
      ['Genre',  v.genre],
      ['Rating', state.rating],
      ['Size',   state.currentSize + ' cm'],
      ['Photo',  state.photoFile ? '✓ Uploaded' : '✗ Missing'],
    ];
    summary.innerHTML = lines.map(function (l) {
      return '<div><strong>' + l[0] + '</strong>' + l[1] + '</div>';
    }).join('');
  }

  /* ── VALIDATION ───────────────────────────────────────── */
  // BUG FIX: all fields are now mandatory per step
  function validateStep(n) {
    if (n === 1) {
      if (!state.photoFile) { showError('Please upload a photo before continuing.'); return false; }
    }
    if (n === 2) {
      var title = els.titleInput && els.titleInput.value.trim();
      var desc  = els.descInput  && els.descInput.value.trim();
      if (!title) { if (els.titleInput) els.titleInput.classList.add('np-field--error'); showError('Please enter a title before continuing.'); return false; }
      if (!desc)  { if (els.descInput)  els.descInput.classList.add('np-field--error');  showError('Please enter a description before continuing.'); return false; }
    }
    if (n === 3) {
      var cast  = els.castInput  && els.castInput.value.trim();
      var year  = els.yearInput  && els.yearInput.value.trim();
      var genre = els.genreInput && els.genreInput.value.trim();
      if (!cast)  { if (els.castInput)  els.castInput.classList.add('np-field--error');  showError('Please enter the cast (names) before continuing.'); return false; }
      if (!year)  { if (els.yearInput)  els.yearInput.classList.add('np-field--error');  showError('Please enter a year before continuing.'); return false; }
      if (!genre) { if (els.genreInput) els.genreInput.classList.add('np-field--error'); showError('Please enter a genre before continuing.'); return false; }
    }
    return true;
  }

  /* ── EVENTS ───────────────────────────────────────────── */
  function bindEvents() {
    ['titleInput','descInput','castInput','yearInput','genreInput'].forEach(function (k) {
      if (!els[k]) return;
      els[k].addEventListener('input', updatePreview);
      // Clear error state as soon as the user starts typing
      els[k].addEventListener('input', function(){ this.classList.remove('np-field--error'); });
    });
    if (els.matchSlider) {
      els.matchSlider.addEventListener('input', function () {
        els.matchDisplay.textContent = this.value + '%'; updatePreview();
      });
    }
    document.querySelectorAll('.np-rating-btn').forEach(function (btn) {
      btn.addEventListener('click', function () {
        document.querySelectorAll('.np-rating-btn').forEach(function (b) { b.classList.remove('active'); });
        this.classList.add('active'); state.rating = this.dataset.rating; updatePreview();
      });
    });

    if (els.photoInput) els.photoInput.addEventListener('change', function () { handlePhoto(this.files[0]); });
    if (els.uploadZone) {
      els.uploadZone.addEventListener('dragover',  function (e) { e.preventDefault(); els.uploadZone.classList.add('drag-over'); });
      els.uploadZone.addEventListener('dragleave', function ()  { els.uploadZone.classList.remove('drag-over'); });
      els.uploadZone.addEventListener('drop', function (e) {
        e.preventDefault(); els.uploadZone.classList.remove('drag-over');
        var f = e.dataTransfer.files[0];
        if (f && f.type.startsWith('image/')) handlePhoto(f);
      });
    }

    document.querySelectorAll('.np-pill[data-option]').forEach(function (pill) {
      pill.addEventListener('click', function () {
        if (this.classList.contains('unavailable')) return;
        var opt = this.dataset.option;
        document.querySelectorAll('.np-pill[data-option="' + opt + '"]').forEach(function (p) { p.classList.remove('active'); });
        this.classList.add('active');
        state.selectedOptions[opt] = this.dataset.value;
        if (this.dataset.value in SIZE_CONFIG) { state.currentSize = this.dataset.value; updatePosterRatio(this.dataset.value); updateQuality(); }
        resolveVariant(); scheduleGradient();
        /* Re-snap so switching colour or type visibly re-seats the frame. */
        applyFrame(state.step >= 4, true);
      });
    });

    if (els.btnNext) els.btnNext.addEventListener('click', function () {
      if (!validateStep(state.step)) return;
      if (state.step < TOTAL_STEPS) goToStep(state.step + 1);
    });
    if (els.btnPrev) els.btnPrev.addEventListener('click', function () {
      if (state.step > 1) goToStep(state.step - 1);
    });

    adjustCanvas = g('np-adjust-canvas');
    if (adjustCanvas) adjustCtx = adjustCanvas.getContext('2d');
    var adjustBtn   = g('np-adjust-btn');
    var adjustClose = g('np-adjust-close');
    var adjustApply = g('np-adjust-apply');
    var panReset    = g('np-pan-reset');
    if (adjustBtn)   adjustBtn.addEventListener('click', openAdjustModal);
    if (adjustClose) adjustClose.addEventListener('click', closeAdjustModal);
    if (adjustApply) adjustApply.addEventListener('click', closeAdjustModal);
    if (panReset)    panReset.addEventListener('click', function () { state.panX = 0; state.panY = 0; drawAdjustCanvas(); applyPanToPreview(); });

    document.querySelectorAll('.np-arrow-btn[data-dx]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var dx = parseFloat(this.dataset.dx), dy = parseFloat(this.dataset.dy);
        if (!dx && !dy) return;
        state.panX = clamp(state.panX - dx * 0.08);
        state.panY = clamp(state.panY - dy * 0.08);
        drawAdjustCanvas(); applyPanToPreview();
      });
    });

    if (adjustCanvas) {
      adjustCanvas.addEventListener('mousedown',  onDragStart);
      adjustCanvas.addEventListener('touchstart', onDragStart, { passive: true });
    }
    window.addEventListener('mousemove', onDragMove);
    window.addEventListener('mouseup',   onDragEnd);
    var modal = g('np-adjust-modal');
    if (modal) {
      modal.addEventListener('touchmove', onDragMove, { passive: false });
      modal.addEventListener('touchend',  onDragEnd,  { passive: true });
    }

    if (window.ResizeObserver && els.poster) new ResizeObserver(scheduleGradient).observe(els.poster);
    if (els.shopifyForm) els.shopifyForm.addEventListener('submit', handleSubmit, true);
  }

  /* ── PHOTO ────────────────────────────────────────────── */
  function handlePhoto(file) {
    if (!file) return;
    state.photoFile = file; state.panX = 0; state.panY = 0;
    if (state.photoURL) URL.revokeObjectURL(state.photoURL);
    state.photoURL = URL.createObjectURL(file);
    if (els.thumbPreview)     { els.thumbPreview.src = state.photoURL; els.thumbPreview.style.display = 'block'; }
    if (els.photoPlaceholder) els.photoPlaceholder.style.display = 'none';
    if (els.posterImg)        { els.posterImg.src = state.photoURL; els.posterImg.style.display = 'block'; els.posterImg.style.objectPosition = '50% 50%'; }
    var aw = g('np-adjust-wrap'); if (aw) aw.style.display = 'block';
    adjustImg = null;
    photoDims = { w: 0, h: 0 };
    scheduleDraftSave();
    (function (forFile) {
      var probe = new Image();
      probe.onload = function () {
        /* The customer may have swapped the photo while this loaded. */
        if (state.photoFile !== forFile) return;
        photoDims = { w: probe.naturalWidth, h: probe.naturalHeight };
        updateQuality();
      };
      probe.src = state.photoURL;
    })(state.photoFile);
    scheduleGradient();
  }


  /* ── RESOLUTION GUARD ─────────────────────────────────
     Unlike the collage, one photo is stretched across the entire poster here,
     so the requirement is the full print size: 50x70cm at 150 DPI needs about
     2953x4134 px (12.2 MP). A typical forwarded phone image is nowhere near
     that and would previously have been printed with nobody warned. The old
     "minimum 1MB" hint was a file-size proxy, which says nothing useful about
     pixel dimensions — a heavily-compressed 12 MP shot can be under 1 MB and a
     1 MP screenshot can be over it. */
  var photoDims = { w: 0, h: 0 };

  function assessPhoto() {
    if (!photoDims.w || !photoDims.h) return null;
    var cfg = SIZE_CONFIG[state.currentSize] || SIZE_CONFIG[DEFAULT_SIZE];
    var dpi = Math.min(photoDims.w / (cfg.wCm / 2.54), photoDims.h / (cfg.hCm / 2.54));
    return { dpi: Math.round(dpi), ratio: dpi / MIN_DPI };
  }

  function updateQuality() {
    var el   = g('np-quality');
    var prop = g('np-prop-quality');
    var a    = assessPhoto();

    if (!a) {
      if (el) el.style.display = 'none';
      if (prop) prop.value = '';
      return;
    }

    var level, icon, msg;
    if (a.ratio >= 1)         { level = 'good';    icon = '✓'; msg = 'Great resolution for ' + state.currentSize + ' cm.'; }
    else if (a.ratio >= 0.75) { level = 'good';    icon = '✓'; msg = 'Good resolution for ' + state.currentSize + ' cm.'; }
    else if (a.ratio >= 0.5)  { level = 'low';     icon = '!'; msg = 'This photo may look soft at ' + state.currentSize + ' cm. A larger file or a smaller size will print sharper.'; }
    else                      { level = 'verylow'; icon = '!'; msg = 'This photo is quite low resolution for ' + state.currentSize + ' cm and will look blurry in print. We recommend a larger original or a smaller size.'; }

    if (el) {
      el.className = 'np-quality np-quality--' + level;
      el.style.display = '';
      el.innerHTML = '<span class="np-quality-icon">' + icon + '</span><span>' + msg + '</span>';
    }
    /* Recorded on the order the way Custom Frame does, so a print complaint can
       be checked against what the customer was shown. */
    if (prop) {
      prop.value = (level === 'good' ? 'OK' : level === 'low' ? 'Low' : 'Very low') +
                   ' (~' + a.dpi + ' DPI at ' + state.currentSize + ' cm)';
    }
  }

  /* ── RATIO ────────────────────────────────────────────── */
  function updatePosterRatio(key) {
    if (!els.poster) return;
    var cfg = SIZE_CONFIG[key]; if (!cfg) return;
    Object.values(SIZE_CONFIG).forEach(function (c) { els.poster.classList.remove(c.ratio); });
    els.poster.classList.add(cfg.ratio);
  }


  /* ── PHRASE PRESETS ───────────────────────────────────
     The dropdown carries the wording and each option supplies the matching
     second line via data attributes, so the pair always reads together.
     Custom clears both and reveals the free-text fields. */
  function applyPhraseSelection(focusCustom) {
    var sel = g('np-phrase');
    if (!sel) return;
    var wrap = g('np-custom-text');
    var head = g('np-title');
    var sub  = g('np-desc');
    var edit = g('np-phrase-edit');
    var isCustom = sel.value === 'custom';

    if (wrap) wrap.style.display = isCustom ? '' : 'none';
    if (edit) edit.style.display = isCustom ? 'none' : '';

    if (isCustom) {
      if (focusCustom) {
        if (head) { head.value = ''; head.focus(); }
        if (sub)  sub.value = '';
      }
    } else {
      var opt = sel.options[sel.selectedIndex];
      if (head) head.value = (opt && opt.dataset.headline) || '';
      if (sub)  sub.value  = (opt && opt.dataset.subline)  || '';
    }
    updatePreview(); scheduleGradient();
  }

  function initPhrasePresets() {
    var sel = g('np-phrase');
    if (!sel) return;
    sel.addEventListener('change', function () { applyPhraseSelection(true); });

    var edit = g('np-phrase-edit');
    if (edit) edit.addEventListener('click', function () {
      /* Keep the wording already chosen, but make it editable. */
      var opt  = sel.options[sel.selectedIndex];
      var h = (opt && opt.dataset.headline) || '';
      var s = (opt && opt.dataset.subline)  || '';
      sel.value = 'custom';
      applyPhraseSelection(false);
      var head = g('np-title'), sub = g('np-desc');
      if (head) { head.value = h; head.focus(); }
      if (sub)  sub.value = s;
      updatePreview(); scheduleGradient();
    });

    applyPhraseSelection(false);
  }

  /* ── GRADIENT OVERLAY ─────────────────────────────────── */
  function scheduleGradient() {
    if (gradRaf) cancelAnimationFrame(gradRaf);
    gradRaf = requestAnimationFrame(drawGradientOverlay);
  }
  function drawGradientOverlay() {
    gradRaf = null;
    var canvas = els.gradCanvas; if (!canvas || !els.poster) return;
    var W = els.poster.offsetWidth, H = els.poster.offsetHeight;
    if (!W || !H) return;
    var dpr = window.devicePixelRatio || 1;
    canvas.width = W * dpr; canvas.height = H * dpr;
    canvas.style.width = W + 'px'; canvas.style.height = H + 'px';
    var ctx = canvas.getContext('2d');
    ctx.scale(dpr, dpr);
    var cfg = SIZE_CONFIG[state.currentSize] || SIZE_CONFIG[DEFAULT_SIZE];
    var tg = ctx.createLinearGradient(0, 0, 0, TOP_GRAD_H);
    tg.addColorStop(0,'rgba(0,0,0,0.72)'); tg.addColorStop(1,'rgba(0,0,0,0)');
    ctx.fillStyle = tg; ctx.fillRect(0, 0, W, TOP_GRAD_H);
    ctx.fillStyle = '#000'; ctx.fillRect(0, H - cfg.solidPx, W, cfg.solidPx);
    var fs = H - cfg.solidPx - cfg.fadePx;
    var fg = ctx.createLinearGradient(0, fs, 0, H - cfg.solidPx);
    fg.addColorStop(0,'rgba(0,0,0,0)'); fg.addColorStop(0.4,'rgba(0,0,0,0.5)'); fg.addColorStop(1,'rgba(0,0,0,1)');
    ctx.fillStyle = fg; ctx.fillRect(0, fs, W, cfg.fadePx);
    drawWatermark(ctx, W, H);
  }

  /* ── PREVIEW TEXT ─────────────────────────────────────── */
  function updatePreview() {
    var v = getValues();
    if (els.pTitle)  els.pTitle.textContent  = v.title;
    if (els.pDesc)   els.pDesc.textContent   = v.desc;
    if (els.pYear)   els.pYear.textContent   = v.year;
    if (els.pMatch)  els.pMatch.textContent  = v.match + '% Match';
    if (els.pRating) els.pRating.textContent = state.rating;
    if (els.pCast)   els.pCast.innerHTML = 'Cast: <span>' + v.cast + '</span> &nbsp;·&nbsp; Genre: <span>' + v.genre + '</span>';
  }

  // BUG FIX: getValues returns empty strings for blank fields.
  // Fallback placeholder strings are used only in the live preview display (updatePreview),
  // NOT baked into the canvas render — so Bishoy's file only contains what the customer typed.
  function getValues() {
    return {
      title: (els.titleInput  && els.titleInput.value.trim())  || '',
      desc:  (els.descInput   && els.descInput.value.trim())   || '',
      cast:  (els.castInput   && els.castInput.value.trim())   || '',
      year:  (els.yearInput   && els.yearInput.value.trim())   || '',
      genre: (els.genreInput  && els.genreInput.value.trim())  || '',
      match: (els.matchSlider && els.matchSlider.value) || '100',
    };
  }

  // Separate helper used only by updatePreview so placeholder text shows in the live UI
  function getDisplayValues() {
    var v = getValues();
    return {
      title: v.title || 'OUR STORY',
      desc:  v.desc  || 'The love story that changed everything.',
      cast:  v.cast  || 'Names here',
      year:  v.year  || String(new Date().getFullYear()),
      genre: v.genre || 'Romance · Drama · Forever',
      match: v.match,
    };
  }

  /* Override updatePreview to use display values for the live poster only */
  function updatePreview() {
    var v = getDisplayValues();
    if (els.pTitle)  els.pTitle.textContent  = v.title;
    if (els.pDesc)   els.pDesc.textContent   = v.desc;
    if (els.pYear)   els.pYear.textContent   = v.year;
    if (els.pMatch)  els.pMatch.textContent  = v.match + '% Match';
    if (els.pRating) els.pRating.textContent = state.rating;
    if (els.pCast)   els.pCast.innerHTML = 'Cast: <span>' + v.cast + '</span> &nbsp;·&nbsp; Genre: <span>' + v.genre + '</span>';
  }


  /* ── FRAME MOCKUP ─────────────────────────────────────── */
  /* Matched on the option VALUE rather than the option NAME: these products
     disagree on naming ("Type" vs "Material", "Size" vs "Size (in cm)") while
     the values are consistent across the catalogue. */
  var FRAME_MATERIALS = {
    'Premium Wood': { w: 20 },
    'Hard Fiber':   { w: 12 },
  };
  var FRAME_FINISHES = {
    'Black':        { face: 'linear-gradient(145deg,#3d3d3d 0%,#161616 45%,#000000 100%)', edge: 'rgba(255,255,255,0.10)' },
    'White':        { face: 'linear-gradient(145deg,#ffffff 0%,#efefef 45%,#d6d6d6 100%)', edge: 'rgba(0,0,0,0.14)' },
    'Light Wooden': { face: 'linear-gradient(145deg,#e3c093 0%,#c89c62 45%,#a67c46 100%)', edge: 'rgba(0,0,0,0.16)' },
  };

  function chosenFrom(map) {
    for (var k in state.selectedOptions) {
      if (!Object.prototype.hasOwnProperty.call(state.selectedOptions, k)) continue;
      if (map[state.selectedOptions[k]]) return state.selectedOptions[k];
    }
    return null;
  }

  function applyFrame(show, snap) {
    var shell = document.querySelector('.np-poster-shell');
    if (!shell) return;

    if (!show) {
      shell.classList.remove('np-framed', 'np-frame-snap');
      return;
    }

    var mat = FRAME_MATERIALS[chosenFrom(FRAME_MATERIALS)] || { w: 14 };
    var fin = FRAME_FINISHES[chosenFrom(FRAME_FINISHES)]   || FRAME_FINISHES['Black'];

    shell.style.setProperty('--np-frame-w',    mat.w + 'px');
    shell.style.setProperty('--np-frame-face', fin.face);
    shell.style.setProperty('--np-frame-edge', fin.edge);

    var wasFramed = shell.classList.contains('np-framed');
    shell.classList.add('np-framed');

    if (snap || !wasFramed) {
      shell.classList.remove('np-frame-snap');
      void shell.offsetWidth; /* force reflow so the animation restarts */
      shell.classList.add('np-frame-snap');
    }
  }

  /* ── VARIANT ──────────────────────────────────────────── */
  function resolveVariant() {
    var variants = window.npVariants; if (!variants || !els.variantInput) return;
    var names = Object.keys(state.selectedOptions), found = null;
    for (var i = 0; i < variants.length; i++) {
      var v = variants[i];
      if (names.every(function (n, idx) { return v['option' + (idx + 1)] === state.selectedOptions[n]; })) { found = v; break; }
    }
    if (!found) return;
    els.variantInput.value = found.id;
    /* The price is rendered both beside the pills on step 4 and again on
       Review, so every node is addressed by class — otherwise the customer
       picks a variant on step 4 and the figure only catches up on step 5. */
    var npMoney = function (cents) {
      return (cents / 100).toLocaleString('en-US', { minimumFractionDigits:0, maximumFractionDigits:0 }) + ' EGP';
    };
    var npShowCompare = !!(found.compareAt && found.compareAt > found.price);
    document.querySelectorAll('.np-js-price').forEach(function (el) {
      el.textContent = npMoney(found.price);
    });
    document.querySelectorAll('.np-js-price-compare').forEach(function (el) {
      if (npShowCompare) { el.textContent = npMoney(found.compareAt); el.style.display = ''; }
      else { el.style.display = 'none'; }
    });
    if (els.atcBtn && !els.atcBtn.dataset.sparkBusy) {
      els.atcBtn.disabled = !found.available;
      els.atcBtn.textContent = found.available ? '🛒 Add to Cart' : 'Out of Stock';
    }
  }

  /* ── ADJUST MODAL ─────────────────────────────────────── */
  function openAdjustModal() {
    var modal = g('np-adjust-modal'); if (!modal || !state.photoFile) return;
    modal.style.display = 'flex'; document.body.style.overflow = 'hidden';
    if (!adjustImg || adjustImg._src !== state.photoURL) {
      adjustImg = new Image(); adjustImg._src = state.photoURL;
      adjustImg.onload = function () { requestAnimationFrame(drawAdjustCanvas); };
      adjustImg.src = state.photoURL;
    } else { requestAnimationFrame(drawAdjustCanvas); }
  }
  function closeAdjustModal() {
    var modal = g('np-adjust-modal'); if (modal) modal.style.display = 'none';
    document.body.style.overflow = ''; applyPanToPreview();
  }
  function drawAdjustCanvas() {
    if (!adjustCanvas || !adjustCtx || !adjustImg || !adjustImg.complete) return;
    var cfg = SIZE_CONFIG[state.currentSize] || SIZE_CONFIG[DEFAULT_SIZE];
    var CW = (adjustCanvas.parentElement && adjustCanvas.parentElement.offsetWidth) || 320;
    if (CW < 100) CW = 320;
    var CH = Math.round(CW * cfg.hCm / cfg.wCm);
    var dpr = window.devicePixelRatio || 1;
    adjustCanvas.width = CW * dpr; adjustCanvas.height = CH * dpr;
    adjustCanvas.style.width = CW + 'px'; adjustCanvas.style.height = CH + 'px';
    adjustCtx.save(); adjustCtx.scale(dpr, dpr);
    var iw = adjustImg.naturalWidth, ih = adjustImg.naturalHeight;
    var sc = Math.max(CW / iw, CH / ih);
    var dw = iw * sc, dh = ih * sc;
    adjustCtx.drawImage(adjustImg, (CW-dw)/2 - state.panX*(dw-CW)/2, (CH-dh)/2 - state.panY*(dh-CH)/2, dw, dh);
    var szX = safePx(CW, cfg.wCm), szY = safePx(CH, cfg.hCm);
    adjustCtx.strokeStyle = 'rgba(255,255,255,0.5)'; adjustCtx.lineWidth = 1.5; adjustCtx.setLineDash([5,4]);
    adjustCtx.strokeRect(szX, szY, CW-szX*2, CH-szY*2);
    adjustCtx.restore();
  }

  /* ── DRAG ─────────────────────────────────────────────── */
  function onDragStart(e) {
    if (!state.photoFile) return;
    if (e.target !== adjustCanvas) return;
    drag.active = true;
    var pt = e.touches ? e.touches[0] : e;
    drag.startX = pt.clientX; drag.startY = pt.clientY;
    drag.startPanX = state.panX; drag.startPanY = state.panY;
  }
  function onDragMove(e) {
    if (!drag.active) return;
    if (e.cancelable) e.preventDefault();
    var pt = e.touches ? e.touches[0] : e;
    var CW = adjustCanvas ? (adjustCanvas.offsetWidth  || 320) : 320;
    var CH = adjustCanvas ? (adjustCanvas.offsetHeight || 480) : 480;
    state.panX = clamp(drag.startPanX - (pt.clientX - drag.startX) / CW * 2);
    state.panY = clamp(drag.startPanY - (pt.clientY - drag.startY) / CH * 2);
    drawAdjustCanvas();
  }
  function onDragEnd() { drag.active = false; }
  function clamp(v) { return Math.max(-1, Math.min(1, v)); }

  function applyPanToPreview() {
    if (!els.posterImg) return;
    els.posterImg.style.objectPosition = ((state.panX+1)/2*100).toFixed(1)+'% ' + ((state.panY+1)/2*100).toFixed(1)+'%';
  }

  /* ── WATERMARK ────────────────────────────────────────── */
  function drawWatermark(ctx, W, H) {
    ctx.save();
    var fontSize = Math.max(8, Math.round(W * 0.022));
    ctx.font         = fontSize + 'px sans-serif';
    ctx.fillStyle    = 'rgba(255,255,255,0.09)';
    ctx.textAlign    = 'center';
    ctx.textBaseline = 'middle';
    var text  = 'SPARK PREVIEW';
    var angle = -Math.PI / 6;
    var textW = ctx.measureText(text).width;
    var stepX = textW + fontSize * 1.5;
    var stepY = fontSize * 2.5;
    ctx.translate(W / 2, H / 2);
    ctx.rotate(angle);
    var d = Math.ceil(Math.sqrt(W * W + H * H));
    for (var row = -d; row < d; row += stepY) {
      for (var col = -d; col < d; col += stepX) {
        ctx.fillText(text, col, row);
      }
    }
    ctx.restore();
  }

  /* ── CANVAS RENDER ────────────────────────────────────── */
  function renderToCanvas(W, H, s, withWatermark, callback) {
    if (!state.photoURL) { callback(null); return; }
    var cfg     = SIZE_CONFIG[state.currentSize] || SIZE_CONFIG[DEFAULT_SIZE];
    var solidPx = cfg.solidPx * s, fadePx = cfg.fadePx * s;
    var szX = safePx(W, cfg.wCm), szY = safePx(H, cfg.hCm);
    var canvas = document.createElement('canvas');
    canvas.width = W; canvas.height = H;
    var ctx = canvas.getContext('2d');
    var img = new Image();
    img.onload = function () {
      ctx.fillStyle = '#000'; ctx.fillRect(0, 0, W, H);
      var iw = img.naturalWidth, ih = img.naturalHeight;
      var sc = Math.max(W / iw, H / ih);
      var dw = iw * sc, dh = ih * sc;
      var overX = Math.max(0, (dw - W) / 2);
      var overY = Math.max(0, (dh - H) / 2);
      ctx.drawImage(img, (W-dw)/2 - state.panX*overX, (H-dh)/2 - state.panY*overY, dw, dh);
      var tg = ctx.createLinearGradient(0, 0, 0, TOP_GRAD_H * s);
      tg.addColorStop(0,'rgba(0,0,0,0.72)'); tg.addColorStop(1,'rgba(0,0,0,0)');
      ctx.fillStyle = tg; ctx.fillRect(0, 0, W, TOP_GRAD_H * s);
      ctx.fillStyle = '#000'; ctx.fillRect(0, H-solidPx, W, solidPx);
      var fs = H-solidPx-fadePx;
      var fg = ctx.createLinearGradient(0, fs, 0, H-solidPx);
      fg.addColorStop(0,'rgba(0,0,0,0)'); fg.addColorStop(0.4,'rgba(0,0,0,0.5)'); fg.addColorStop(1,'rgba(0,0,0,1)');
      ctx.fillStyle = fg; ctx.fillRect(0, fs, W, fadePx);
      drawText(ctx, W, H, s, szX, szY);
      if (withWatermark) drawWatermark(ctx, W, H);
      callback(canvas);
    };
    img.onerror = function () { callback(null); };
    img.src = state.photoURL;
  }

  /* ── RENDER POSTER → FILES ────────────────────────────── */
  function renderPosterToFile(callback) {
    if (!state.photoURL || !els.poster) { callback(null, null); return; }
    var cfg      = SIZE_CONFIG[state.currentSize] || SIZE_CONFIG[DEFAULT_SIZE];
    var CM       = 1 / 2.54;
    var fullW    = Math.round(cfg.wCm * CM * MIN_DPI);
    var fullH    = Math.round(cfg.hCm * CM * MIN_DPI);
    var previewW = 220;
    var previewH = Math.round(previewW * cfg.hCm / cfg.wCm);
    /* The frame mockup pads the shell, which narrows #np-poster and would shift
       the scale factors below — and with it the proportions of the file that
       actually gets printed, since canvas text is scaled by this ratio while
       the DOM text stays at a fixed px size. Measure with the frame off so the
       output is identical whether or not the customer framed the preview.
       renderToCanvas takes the scale as an argument and does no further DOM
       measurement, so restoring the class straight away is safe. */
    var frameShell = document.querySelector('.np-poster-shell.np-framed');
    if (frameShell) frameShell.classList.remove('np-framed');
    var domW     = els.poster.offsetWidth || 360;
    if (frameShell) frameShell.classList.add('np-framed');

    var sF       = fullW / domW;
    var sP       = previewW / domW;

    renderToCanvas(fullW, fullH, sF, false, function (fullCanvas) {
      if (!fullCanvas) { callback(null, null); return; }
      fullCanvas.toBlob(function (blob) {
        if (!blob) { callback(null, null); return; }
        var cleanFile = new File([blob], 'netflix-poster.jpg', { type:'image/jpeg' });
        renderToCanvas(previewW, previewH, sP, true, function (prevCanvas) {
          if (!prevCanvas) { callback(cleanFile, null); return; }
          prevCanvas.toBlob(function (blob2) {
            var previewFile = blob2 ? new File([blob2], 'netflix-poster-preview.jpg', { type:'image/jpeg' }) : null;
            callback(cleanFile, previewFile);
          }, 'image/jpeg', 0.65);
        });
      }, 'image/jpeg', 0.93);
    });
  }

  /* ── DRAW TEXT ────────────────────────────────────────── */
  // BUG FIX: drawText uses getValues() (no fallbacks) so blank fields render blank on the print file
  function drawText(ctx, W, H, s, szX, szY) {
    var v = getValues();
    ctx.textBaseline = 'alphabetic';
    var padX = szX, y = H - szY;

    ctx.font = 'normal '+(9*s)+'px sans-serif'; ctx.fillStyle = 'rgba(255,255,255,0.45)';
    ctx.fillText('Cast: '+v.cast+'  ·  Genre: '+v.genre, padX, y); y -= 15*s;

    ctx.font = 'normal '+(10*s)+'px sans-serif'; ctx.fillStyle = 'rgba(255,255,255,0.75)';
    var dl = wrapText(ctx, v.desc, W-padX*2, 3);
    for (var i = dl.length-1; i >= 0; i--) { ctx.fillText(dl[i], padX, y); y -= 15*s; } y -= 4*s;

    ctx.fillStyle = '#E50914'; ctx.fillRect(padX, y-16*s, 20*s, 18*s);
    ctx.fillStyle = '#fff'; ctx.font = 'bold '+(9*s)+'px sans-serif'; ctx.fillText('#1', padX+2*s, y-2*s);
    ctx.fillStyle = 'rgba(255,255,255,0.8)'; ctx.font = '500 '+(10*s)+'px sans-serif';
    ctx.fillText('Most watched today', padX+24*s, y-2*s); y -= 26*s;

    ctx.font = 'bold '+(12*s)+'px sans-serif'; ctx.fillStyle = '#46d369';
    ctx.fillText(v.match+'% Match', padX, y);
    var mW = ctx.measureText(v.match+'% Match').width+10*s;
    ctx.font = 'normal '+(12*s)+'px sans-serif'; ctx.fillStyle = 'rgba(255,255,255,0.7)';
    ctx.fillText(v.year, padX+mW, y);
    var yW = ctx.measureText(v.year).width+10*s;
    var hdX = padX+mW+yW;
    ctx.strokeStyle = 'rgba(255,255,255,0.4)'; ctx.lineWidth = 0.5*s;
    ctx.strokeRect(hdX, y-12*s, 24*s, 15*s);
    ctx.font = 'normal '+(8*s)+'px sans-serif'; ctx.fillStyle = 'rgba(255,255,255,0.7)';
    ctx.fillText('HD', hdX+3*s, y);
    var rtX = hdX+30*s;
    ctx.fillStyle = '#E50914'; ctx.fillRect(rtX, y-12*s, 36*s, 15*s);
    ctx.fillStyle = '#fff'; ctx.font = 'bold '+(8*s)+'px sans-serif';
    ctx.fillText(state.rating, rtX+3*s, y); y -= 26*s;

    ctx.fillStyle = '#fff'; ctx.beginPath(); roundRect(ctx, padX, y-20*s, 72*s, 22*s, 3*s); ctx.fill();
    var tx = padX+10*s, ty = y-10*s, th = 9*s;
    ctx.fillStyle = '#000'; ctx.beginPath();
    ctx.moveTo(tx, ty-th/2); ctx.lineTo(tx, ty+th/2); ctx.lineTo(tx+th*0.85, ty);
    ctx.closePath(); ctx.fill();
    ctx.font = 'bold '+(11*s)+'px sans-serif'; ctx.fillText('Play', padX+22*s, y-4*s);
    ctx.fillStyle = 'rgba(109,109,110,0.75)'; ctx.beginPath(); roundRect(ctx, padX+78*s, y-20*s, 78*s, 22*s, 3*s); ctx.fill();
    ctx.fillStyle = '#fff'; ctx.font = '500 '+(11*s)+'px sans-serif'; ctx.fillText('+ My List', padX+86*s, y-4*s);
    y -= 34*s;

    var tsz = Math.min(40, Math.max(28, W/(s*9)))*s;
    ctx.font = 'normal '+tsz+'px "Bebas Neue",serif'; ctx.fillStyle = '#fff';
    ctx.shadowColor = 'rgba(0,0,0,0.5)'; ctx.shadowBlur = 6*s;
    ctx.fillText(v.title, padX, y); ctx.shadowBlur = 0;

    var nX = szX, nY = szY, nH = 28*s, nW = nH;
    if (logoImg && logoImg.complete && logoImg.naturalWidth) {
      nW = nH*(logoImg.naturalWidth/logoImg.naturalHeight);
      ctx.drawImage(logoImg, nX, nY, nW, nH);
    } else { ctx.fillStyle = '#E50914'; ctx.fillRect(nX, nY, nH*0.75, nH); nW = nH*0.75; }
    ctx.fillStyle = 'rgba(255,255,255,0.55)'; ctx.font = 'normal '+(8*s)+'px sans-serif';
    ctx.fillText('ORIGINAL SERIES', nX+nW+6*s, nY+nH*0.65);
  }

  function wrapText(ctx, text, maxW, maxLines) {
    var words = text.split(' '), lines = [], line = '';
    words.forEach(function (w) { var t = line?line+' '+w:w; if (ctx.measureText(t).width>maxW&&line){lines.push(line);line=w;}else line=t; });
    if (line) lines.push(line);
    return lines.slice(0, maxLines);
  }
  function roundRect(ctx, x, y, w, h, r) {
    ctx.moveTo(x+r,y); ctx.lineTo(x+w-r,y); ctx.quadraticCurveTo(x+w,y,x+w,y+r);
    ctx.lineTo(x+w,y+h-r); ctx.quadraticCurveTo(x+w,y+h,x+w-r,y+h);
    ctx.lineTo(x+r,y+h); ctx.quadraticCurveTo(x,y+h,x,y+h-r);
    ctx.lineTo(x,y+r); ctx.quadraticCurveTo(x,y,x+r,y); ctx.closePath();
  }

  /* ── SUBMIT ───────────────────────────────────────────── */
  function handleSubmit(e) {
    e.preventDefault(); e.stopImmediatePropagation();
    // BUG FIX: full validation at submit time as a safety net
    if (!state.photoFile) { showError('Please upload a photo before adding to cart.'); return; }
    var v = getValues();
    if (!v.title) { if (els.titleInput) els.titleInput.classList.add('np-field--error'); showError('Please enter a title.'); goToStep(2); return; }
    if (!v.desc)  { if (els.descInput)  els.descInput.classList.add('np-field--error');  showError('Please enter a description.'); goToStep(2); return; }
    if (!v.cast)  { if (els.castInput)  els.castInput.classList.add('np-field--error');  showError('Please enter the cast (names).'); goToStep(3); return; }
    if (!v.year)  { if (els.yearInput)  els.yearInput.classList.add('np-field--error');  showError('Please enter a year.'); goToStep(3); return; }
    if (!v.genre) { if (els.genreInput) els.genreInput.classList.add('np-field--error'); showError('Please enter a genre.'); goToStep(3); return; }
    if (!els.variantInput || !els.variantInput.value) { showError('Please select all options.'); return; }
    if (els.atcBtn && els.atcBtn.dataset.sparkBusy) return;
    hideError();
    var spin = showSpinner(els.atcBtn);
    spin.label('Rendering poster…');

    setTimeout(function () {
      renderPosterToFile(function (cleanFile, previewFile) {
        if (!cleanFile) { showError('Could not render poster. Please try again.'); spin.restore(); return; }

        try {
          var dt1 = new DataTransfer(); dt1.items.add(cleanFile);
          els.hiddenPhotoInput.files = dt1.files;
        } catch (err) { showError('Upload not supported. Please use Chrome or Safari.'); spin.restore(); return; }

        if (previewFile && els.previewPhotoInput) {
          try { var dt2 = new DataTransfer(); dt2.items.add(previewFile); els.previewPhotoInput.files = dt2.files; } catch(e) {}
        }

        spin.label('Uploading…');
        fetch('/cart/add.js', { method:'POST', credentials:'same-origin', headers:{'X-Requested-With':'XMLHttpRequest'}, body: sparkWithSections(new FormData(els.shopifyForm)) })
          .then(function (res) {
            if (!res.ok) return res.json().then(function (d) { throw new Error(d.description||d.message||'Cart error'); });
            return res.json();
          })
          .then(function (response) {
            spin.label('Added! ✓');
            setTimeout(function () { spin.restore(); }, 1200);
            draftClear();
            resetCustomizer();
            sparkCartRefresh(response, 'netflix-poster');
          })
          .catch(function (err) { showError(err.message || 'Something went wrong. Please try again.'); spin.restore(); });
      });
    }, 50);
  }



  /* ── DRAFTS ───────────────────────────────────────────
     Settings and text live in localStorage; the photo File objects live in
     IndexedDB because they cannot be JSON-serialised. Every entry point is
     wrapped — storage can be unavailable (private mode), full, or blocked, and
     none of that should stop someone building a poster. */
  var DRAFT_KEY   = 'spark-draft-netflix';
  var DRAFT_STORE = 'photos';

  function draftDB(cb) {
    try {
      if (!window.indexedDB) return cb(null);
      var req = indexedDB.open('spark-drafts', 1);
      req.onupgradeneeded = function () {
        var db = req.result;
        if (!db.objectStoreNames.contains(DRAFT_STORE)) db.createObjectStore(DRAFT_STORE);
      };
      req.onsuccess = function () { cb(req.result); };
      req.onerror   = function () { cb(null); };
    } catch (e) { cb(null); }
  }

  function draftPutBlobs(value) {
    draftDB(function (db) {
      if (!db) return;
      try {
        var tx = db.transaction(DRAFT_STORE, 'readwrite');
        tx.objectStore(DRAFT_STORE).put(value, DRAFT_KEY);
      } catch (e) {}
    });
  }

  function draftGetBlobs(cb) {
    draftDB(function (db) {
      if (!db) return cb(null);
      try {
        var tx = db.transaction(DRAFT_STORE, 'readonly');
        var r  = tx.objectStore(DRAFT_STORE).get(DRAFT_KEY);
        r.onsuccess = function () { cb(r.result || null); };
        r.onerror   = function () { cb(null); };
      } catch (e) { cb(null); }
    });
  }

  function draftClear() {
    try { localStorage.removeItem(DRAFT_KEY); } catch (e) {}
    draftDB(function (db) {
      if (!db) return;
      try {
        var tx = db.transaction(DRAFT_STORE, 'readwrite');
        tx.objectStore(DRAFT_STORE).delete(DRAFT_KEY);
      } catch (e) {}
    });
    var bar = g('np-draft');
    if (bar) bar.style.display = 'none';
  }

  var draftTimer = null;
  function scheduleDraftSave() {
    if (draftTimer) clearTimeout(draftTimer);
    draftTimer = setTimeout(saveDraft, 700);
  }

  function fieldVal(id) { var el = g(id); return el ? el.value : ''; }

  function saveDraft() {
    try {
      var meta = {
        v: 1,
        at: Date.now(),
        title: fieldVal('np-title'),
        desc: fieldVal('np-desc'),
        cast: fieldVal('np-cast'),
        year: fieldVal('np-year'),
        genre: fieldVal('np-genre'),
        phrase: fieldVal('np-phrase'),
        rating: state.rating,
        size: state.currentSize,
        hasPhoto: !!state.photoFile
      };
      if (!meta.hasPhoto && !meta.title && !meta.desc && !meta.cast) { draftClear(); return; }
      localStorage.setItem(DRAFT_KEY, JSON.stringify(meta));
      draftPutBlobs(state.photoFile || null);
    } catch (e) {}
  }

  function readDraftMeta() {
    try {
      var raw = localStorage.getItem(DRAFT_KEY);
      if (!raw) return null;
      var meta = JSON.parse(raw);
      if (!meta || meta.v !== 1 || (Date.now() - meta.at) > 7 * 24 * 3600 * 1000) return null;
      return meta;
    } catch (e) { return null; }
  }

  function offerDraft() {
    var meta = readDraftMeta();
    var bar  = g('np-draft');
    if (!meta || !bar) return;
    var msg = g('np-draft-msg');
    if (msg) msg.textContent = 'You have an unfinished poster' + (meta.title ? ' — "' + meta.title + '".' : '.');
    bar.style.display = '';
    var restore = g('np-draft-restore');
    if (restore) restore.addEventListener('click', function () { restoreDraft(meta); });
    var discard = g('np-draft-discard');
    if (discard) discard.addEventListener('click', draftClear);
  }

  function restoreDraft(meta) {
    var set = function (id, v) { var el = g(id); if (el && v != null) el.value = v; };
    set('np-title', meta.title); set('np-desc', meta.desc); set('np-cast', meta.cast);
    var npSel2 = g('np-phrase');
    if (npSel2 && meta.phrase) { npSel2.value = meta.phrase; applyPhraseSelection(false); }
    /* After the preset, so custom wording isn't overwritten by it. */
    set('np-title', meta.title); set('np-desc', meta.desc);
    set('np-year', meta.year);   set('np-genre', meta.genre);

    if (meta.rating) {
      state.rating = meta.rating;
      document.querySelectorAll('.np-rating-btn').forEach(function (b) {
        b.classList.toggle('active', b.dataset.rating === meta.rating);
      });
    }
    if (meta.size) {
      document.querySelectorAll('.np-pill[data-option]').forEach(function (p) {
        if (p.dataset.value === meta.size) p.click();
      });
    }

    draftGetBlobs(function (blob) {
      if (blob) handlePhoto(blob);
      updatePreview();
      scheduleGradient();
    });

    var bar = g('np-draft');
    if (bar) bar.style.display = 'none';
  }

  /* ── CART REFRESH ─────────────────────────────────────────
     The theme refreshes the drawer by asking /cart/add.js to return the
     re-rendered cart sections and handing them to cart.renderContents() — see
     product-form.js. Posting to /cart/add.js without requesting those sections
     adds the line item server-side but leaves the drawer and the icon bubble
     showing stale markup, so the item only appeared after a page reload.
     renderContents() also opens the drawer, so no manual open is needed. */
  function sparkCartEl() {
    return document.querySelector('cart-notification') || document.querySelector('cart-drawer');
  }

  function sparkWithSections(formData) {
    var cart = sparkCartEl();
    if (cart && typeof cart.getSectionsToRender === 'function') {
      formData.append('sections', cart.getSectionsToRender().map(function (s) { return s.id; }));
      formData.append('sections_url', window.location.pathname);
      if (typeof cart.setActiveElement === 'function') cart.setActiveElement(document.activeElement);
    }
    return formData;
  }

  function sparkCartRefresh(response, source) {
    if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      publish(PUB_SUB_EVENTS.cartUpdate, {
        source: source,
        productVariantId: response && response.variant_id,
        cartData: response,
      });
    }
    var cart = sparkCartEl();
    if (!cart) return;
    cart.classList.remove('is-empty');
    if (response && response.sections && typeof cart.renderContents === 'function') {
      cart.renderContents(response);
    } else if (typeof cart.open === 'function') {
      /* No sections came back (older cart element) — at least surface the
         drawer rather than leaving the customer with no feedback. */
      cart.open();
    }
  }

  /* ── RESET ────────────────────────────────────────────── */
  function resetCustomizer() {
    ['titleInput','descInput','castInput','yearInput','genreInput'].forEach(function (k) {
      if (els[k]) { els[k].value = ''; els[k].classList.remove('np-field--error'); }
    });
    if (els.matchSlider) { els.matchSlider.value = '100'; els.matchDisplay.textContent = '100%'; }
    state.rating = 'PG-13';
    document.querySelectorAll('.np-rating-btn').forEach(function (b) { b.classList.toggle('active', b.dataset.rating==='PG-13'); });
    state.photoFile = null; state.panX = 0; state.panY = 0;
    photoDims = { w: 0, h: 0 }; updateQuality();
    if (state.photoURL) { URL.revokeObjectURL(state.photoURL); state.photoURL = null; }
    if (els.posterImg)        { els.posterImg.src=''; els.posterImg.style.display='none'; els.posterImg.style.objectPosition='50% 50%'; }
    if (els.photoPlaceholder) els.photoPlaceholder.style.display = 'flex';
    if (els.thumbPreview)     { els.thumbPreview.src=''; els.thumbPreview.style.display='none'; }
    var aw = g('np-adjust-wrap'); if (aw) aw.style.display = 'none';
    if (els.photoInput)        { try { els.photoInput.files = new DataTransfer().files; } catch(e){} }
    if (els.hiddenPhotoInput)  { try { els.hiddenPhotoInput.files = new DataTransfer().files; } catch(e){} }
    if (els.previewPhotoInput) { try { els.previewPhotoInput.files = new DataTransfer().files; } catch(e){} }
    adjustImg = null;
    var seen = {};
    document.querySelectorAll('.np-pill[data-option]').forEach(function (pill) {
      var opt = pill.dataset.option;
      if (!seen[opt]) { seen[opt]=true; pill.classList.add('active'); state.selectedOptions[opt]=pill.dataset.value; if (pill.dataset.value in SIZE_CONFIG){state.currentSize=pill.dataset.value; updatePosterRatio(pill.dataset.value);} }
      else pill.classList.remove('active');
    });
    var npSel = g('np-phrase'); if (npSel) npSel.selectedIndex = 0;
    applyPhraseSelection(false);
    hideError(); updatePreview(); resolveVariant();
    goToStep(1); scheduleGradient();
  }

  /* ── HELPERS ──────────────────────────────────────────── */
  function showError(msg) {
    if (!els.errorBox) return;
    els.errorBox.textContent = msg; els.errorBox.classList.add('visible');
    els.errorBox.scrollIntoView({ behavior:'smooth', block:'nearest' });
  }
  function hideError() { if (els.errorBox) els.errorBox.classList.remove('visible'); }

  /* ── BOOT ─────────────────────────────────────────────── */
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

})();